import React from 'react';
import { Link } from 'react-router-dom';
import Icon from '../Icon';
import usePageMeta from '../usePageMeta';
import { useContact } from '../SiteContent';
import T from '../components/EditableText';

const NotFound: React.FC = () => {
  const contact = useContact();

  // noindex: Die Auslieferung antwortet aus technischen Gründen mit Status 200
  // (nginx kann eine unbekannte SPA-Route nicht von einer echten unterscheiden),
  // deshalb muss das Meta-Tag verhindern, dass 404-Seiten in den Index geraten.
  usePageMeta('Seite nicht gefunden', 'Die aufgerufene Seite existiert nicht.', {
    noindex: true,
  });

  return (
    <section className="shell shell--prose centered" style={{ paddingTop: 80, paddingBottom: 80 }}>
      <span className="eyebrow">
        <T k="fehlerseite.eyebrow" />
      </span>
      <h1 className="h-hero">
        <T k="fehlerseite.titel" />{' '}
        <span className="accent">
          <T k="fehlerseite.titel-akzent" />
        </span>
      </h1>
      <p className="lead" style={{ marginBottom: 28 }}>
        <T k="fehlerseite.text" />
      </p>
      <div className="btn-row" style={{ justifyContent: 'center' }}>
        <Link to="/" className="btn btn--primary">
          <T k="fehlerseite.cta" />
        </Link>
        <a href={contact.phoneHref} className="btn btn--ghost">
          <Icon name="phone" size={18} />
          {contact.phoneLabel}
        </a>
      </div>
    </section>
  );
};

export default NotFound;
